import axios from "axios";

async function getDocumentByUrl(url: string) {
  // fetch the document
  const documentReq = await axios.get(url);

  // parse the document
  const parser = new DOMParser();
  const doc = parser.parseFromString(documentReq.data, 'text/html');

  // return the document
  return doc;
}

function reattachScripts(domNode: Element) {
  // create reference array
  const refArray = []

  // find all scripts
  const scripts = domNode.querySelectorAll('script');
  for (const script of scripts) {
    const newScript = document.createElement('script');

    // add inline script or src
    if (script.textContent) {
      const inlineScript = document.createTextNode(script.textContent);
      newScript.append(inlineScript);
    } else {
      newScript.src = script.src;
    }

    // keep attributes
    for (let i = 0; i < script.attributes.length; i++) {
      newScript.setAttribute(script.attributes[i].name, script.attributes[i].value);
    }

    // remove old script and append new script
    script.remove();
    document.body.append(newScript);

    // push to ref array
    refArray.push(newScript);
  }

  return refArray;
}

function getEntriesElem(doc: Document, elemId: string) {
  const selector = `fw-filterpel-entries[elem-id="${elemId}"]`;
  const entriesDom = doc.querySelector(selector);

  return entriesDom;
}

function getFiltersElem(doc: Document, elemId: string) {
  const selector = `fw-filterpel-filters[elem-id="${elemId}"]`;
  const filtersDom = doc.querySelector(selector);

  return filtersDom;
}

function getPaginationElem(doc: Document, elemId: string) {
  const selector = `fw-filterpel-pagination[elem-id="${elemId}"]`;
  const paginationDom = doc.querySelector(selector);

  return paginationDom;
}


export {
  getDocumentByUrl,
  reattachScripts,
  getEntriesElem,
  getFiltersElem,
  getPaginationElem,
};
